// Template data transformer

import { BaseTransformer } from './BaseTransformer';

export class TemplateTransformer extends BaseTransformer {
  
  async transform(templateData: Record<string, unknown>): Promise<Record<string, unknown>> {
    console.log(`[TEMPLATE-TRANSFORM] Only copying Standard templates`);
    
    const templateTypeRaw = templateData.type || templateData.templateType || '';
    const templateType = String(templateTypeRaw).toLowerCase();
    
    // Only skip if an explicit non-standard type is provided. Missing/empty => treat as standard
    if (templateType && templateType !== 'standard') {
      console.log(`[TEMPLATE-TRANSFORM] SKIPPED: Template type "${templateType}" is not "Standard"`);
      return { skipped: true, reason: 'Only Standard templates are synced' };
    }

    // Match backend schema: id, name, pinned, archived, advanced, location_id, section_order, owners
    return this.pruneUndefined({
      id: templateData.id,
      name: templateData.name,
      pinned: this.safeBoolean(templateData.pinned),
      archived: this.safeBoolean(templateData.archived),
      advanced: this.safeBoolean(templateData.advanced),
      location_id: templateData.lID,
      section_order: this.ensureArray(templateData.section_order || templateData.sectionOrder),
      owners: this.ensureArray(templateData.owners),
      created_at: templateData.createdAt || this.getCurrentTimestamp(),
      updated_at: this.getCurrentTimestamp()
    });
  }
} 